// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/is-callable.js
// module id = 37
// module chunks = 0